import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DestacadoState } from './destacado.reducers';
import * as fromDestacado from './destacado.reducers';


export const destacadoState = createFeatureSelector<DestacadoState>("destacado");

export const allDestacado = createSelector(
	destacadoState,
	fromDestacado.selectAll
);

export const destacadoReady = createSelector(
	destacadoState,
	state => state.ready
);

export const destacadoMaxQtyToLoad = createSelector(
	destacadoState,
	state => state.maxQtyToLoad
);

export const destacadoStatus = createSelector(
	destacadoState,
	state => state.status
);

export const destacadoCleared = createSelector(
	destacadoState,
	state => state.cleared	
);
